module.exports = __webpack_public_path__ + "static/img/digg-icon.48ffeefc.png";